module.exports = __webpack_public_path__ + "static/media/Fire Blaze Golden_ Buccaneer Bells.fe0125cf.png";